import _ from "lodash";
import $ from 'jquery';
import QRCode from 'qrcode';
import { useEffect, useLayoutEffect, useState } from "react";
import { Button, Divider, Input, Modal } from "semantic-ui-react";
import { ModalControlData, useRequest } from "../hooks/commonHooks";
import { EquipmentConfig, EquipmentData } from "../models/equipment_model";
import '../assets/scss/components/EquipmentComponentPrintQR.scss';
import { notificationControl } from "../controls/notification-control";
import { dialogControl } from "../controls/dialog-control";
import { restRequest } from "../http";

export function EquipmentComponentPrintQR(props: { modalControl: ModalControlData<any> }) {
    const { modalControl } = props;
    const [equipments, setEquipments] = useState<EquipmentData[]>([]);
    const [height, setHeight] = useState(window.innerHeight - 180 + 'px');
    const [addingId, setAddingId] = useState<string>();
    const [addIdLoading, setAddIdLoading] = useState(false);

    useEffect(() => {
        restRequest<EquipmentData[]>('equipments/search_for_print_qr', modalControl.data, 'post').then(setEquipments);
    }, [modalControl.data])

    useLayoutEffect(() => {
        const onWindowResize = () => {
            setHeight(window.innerHeight - 180 + 'px');
        }

        $(window).on('resize', onWindowResize);

        return () => {
            $(window).off('resize', onWindowResize);
        }
    }, []);


    useEffect(() => {
        const printFrame = $('#printFrame')[0] as HTMLIFrameElement;

        if (!equipments || !printFrame?.contentWindow) {
            return;
        }

        (printFrame.contentWindow as any).onLoadEquipments && (printFrame.contentWindow as any).onLoadEquipments(equipments);
    }, [equipments])


    return <>
        <Modal {...modalControl.props} size="fullscreen" closeIcon>
            <Modal.Header>
                <Button onClick={e => {
                    const printFrame = $('#printFrame')[0] as HTMLIFrameElement;
                    if (!printFrame?.contentWindow) {
                        notificationControl.showError('please wait until it\'s loaded');
                        return;
                    }
                    printFrame?.contentWindow.print();
                }} color="blue">Print</Button>
                <div style={{ display: "inline-block", width: '2rem' }}></div>
                <Input size="mini" action loading={addIdLoading}>
                    <input style={{width: '5rem'}} placeholder="ID" value={addingId} onChange={(e) => {
                        const n = parseInt(e.target.value);
                        setAddingId(isNaN(n) ? '' : n + '');
                    }} />
                    <Button as="a" onClick={e => {
                        e.preventDefault();
                        if (!addingId) {
                            notificationControl.showError('invalid ID value');
                            return;
                        }

                        const id = parseInt(addingId);
                        if (equipments.find(e => e.id === id)) {
                            notificationControl.showError('ID already there');
                            return;
                        }
                        setAddIdLoading(true);
                        restRequest<EquipmentData>('equipments/' + addingId).then(data => {
                            setEquipments([...equipments, data]);
                            setAddingId('');
                            notificationControl.showSuccess('add success');
                        }, (e) => {
                            notificationControl.showError(`Equipment with Id=${id} not found`)
                        }).finally(() => setAddIdLoading(false));
                    }}>Add</Button>
                </Input>
            </Modal.Header>
            <Modal.Content style={{ height }}>
                <iframe id="printFrame" src="/inventory_print_qr_frame" width="100%" height="100%" frameBorder={0} onLoad={(e) => {
                    (e.currentTarget.contentWindow as any).onLoadEquipments(equipments);
                }}></iframe>
            </Modal.Content>
        </Modal>
    </>
}

export function EquipmentComponentPrintQrFrame(props: any) {
    const [equipments, setEquipments] = useState<EquipmentData[][][]>([[[]]]);
    (window as any).onLoadEquipments = (equipments: EquipmentData[]) => {
        setEquipments(makeGridArray(equipments));
    }

    useEffect(() => {
        _.flattenDeep(equipments).forEach((e, i) => {
            if (e) {
                QRCode.toDataURL(['id', 'type', 'device', 'brand', 'model', 'number'].map(k => `${k}: ${e[k]}`).join('\n'), { width: 300, margin: 0 }).then(url => {
                    $('#printQRContainer .card img').eq(i).attr('src', url);
                })
            }
        })
    }, [equipments]);

    useEffect(() => {
        $('html, body, #root, #root > .main-content').css('height', 'auto')
    })

    return <div id="printQRContainer">
        {equipments.map((pages, pi) => {
            return <div className="page" key={pi}>
                <table cellPadding={0} cellSpacing={0}>
                    {pages.map((rows, ri) => {
                        return <tr className="row" key={ri}>
                            {rows.map((e, rowIndex) => {
                                return <td className="card" key={rowIndex}>
                                    {e && <>
                                        <div className="text">
                                            <b>ID</b>: {e.id}<br />
                                            <b>Type</b>: {e.type}<br />
                                            <b>Device</b>: {e.device}<br />
                                            <b>Brand</b>: {e.brand}<br />
                                        </div>
                                        <img />

                                        <div className="actions">
                                            <Button size="mini" compact icon="delete" color="red" onClick={event => {
                                                event.preventDefault();
                                                dialogControl.deletionConfirm('Equipment #' + e.id, agree => {
                                                    if (agree) {
                                                        const flattenArray: EquipmentData[] = _.flattenDeep(equipments);
                                                        setEquipments(makeGridArray(flattenArray.filter(ie => ie && ie.id !== e.id)));
                                                    }

                                                    return Promise.resolve();
                                                })

                                            }}></Button>
                                        </div>
                                    </>}
                                </td>
                            })}
                        </tr>
                    })}
                </table>
            </div>
        })}
    </div>
}


function makeGridArray(equipments: EquipmentData[]) {
    const newValue: EquipmentData[][][] = []

    for (let p = 0; p < Math.ceil(equipments.length / 12); p++) {
        const pages: EquipmentData[][] = [];
        for (let r = 0; r < 4; r++) {
            const rows: EquipmentData[] = []
            for (let i = 0; i < 3; i++) {
                rows.push(equipments[p * 12 + r * 3 + i]);
            }

            pages.push(rows);
        }

        newValue.push(pages);
    }

    return newValue;
}